import { useRef } from 'react'
import PaperClip from '../svg/paperclip'

export default function FileSelector({ onSelect }) {
  const fileRef = useRef()

  const handleChange = (e) => {
    const [file] = e.target.files

    onSelect(file)
  }

  const handleClick = (e) => {
    e.preventDefault()

    fileRef.current.click()
  }

  return (
    <div>
      <button onClick={handleClick} type='button'>
        <PaperClip fill='var(--secondary-text-color)' />
      </button>
      <input ref={fileRef} type='file' onChange={handleChange} />

      <style jsx>{`
        button {
          background: none;
        }

        input {
          display: none;
        }
      `}</style>
    </div>
  )
}
